import { updateTenderUserFollowUp } from '@data'
import FollowUpRemarks from '@pages/Admin/Tenderbook/components/FollowUpRemarks'

const UserRemarks = ({ data, update }) => (
	<FollowUpRemarks data={data} update={update} save={(payload) => updateTenderUserFollowUp(payload, data?.user_id)} />
)

export default UserRemarks
